<template>
  <div class="templates">
    <div class="buttons is-pulled-right">
      <b-button
        type="is-primary"
        @click="
          $router.push({
            name: 'configuration.templates.create'
          })
        "
      >
        CREATE
      </b-button>
    </div>
    <base-table
      :service="$options.templateService"
      fetch-func="all"
      :columns="$options.columns"
      ref="baseTable"
    >
      <template #rowIsDefault="{row}">
        <b-switch
          :value="isSetAsDefault(row)"
          type="is-info"
          @input="setAsDefault(row)"
        />
      </template>
      <template #rowActions="{row}">
        <b-button
          @click="
            $router.push({
              name: 'configuration.templates.edit',
              params: { id: row.id }
            })
          "
        >
          Edit
        </b-button>
      </template>
    </base-table>
  </div>
</template>

<script>
import BaseTable from "@/components/partials/BaseTable";
import { TemplateService } from "@/services/template.service";

export default {
  templateService: TemplateService,
  columns: [
    { field: "code", label: "Code" },
    { field: "type", label: "Type" },
    { field: "name", label: "Name" },
    { field: "status", label: "Status" },
    { label: "Set as default", meta: { rowSlot: "rowIsDefault" } },
    {
      label: "",
      meta: {
        rowSlot: "rowActions"
      }
    }
  ],
  components: {
    BaseTable
  },
  computed: {
    user() {
      return this.$store.state.Auth.user;
    }
  },
  mounted() {
    this.$refs.baseTable.fetchData();
  },
  methods: {
    isSetAsDefault(template) {
      const firmAttribtues = this.user.firm.attributes || [];
      const customTemplateAttribute = firmAttribtues.find(
        attribute => attribute.code === "[SYSTEM][ORDER][PDF_TEMPLATE]"
      );

      return (
        customTemplateAttribute && customTemplateAttribute.value == template.id
      );
    },
    setAsDefault(template) {}
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/Templates/index.vue